// extracted by mini-css-extract-plugin
export var gameRules = "GameRules-module--gameRules--no7hh";